export const CLEAR_ERRORS_ACTION = 'clearErrorsAction';

export const UPDATE_FORM = 'updateForm';

export const CHECK_AUTH = 'checkAuth';
export const LOGIN = 'login';
export const REGISTER = 'register';
export const LOGOUT = 'logout';
export const EMAIL_PASSWORD_RESET = 'emailPasswordReset';
export const PASSWORD_RESET = 'passwordReset';

export const TOGGLE_AUTH_DIALOG = 'toggleAuthDialog';


export const GET_EVENTS = 'getEvents';
export const GET_SEASON_EVENTS = 'getSeasonEvents';

export const GET_OPTIONS = 'getOptions';
export const GET_MONTHS = 'getMonths';
export const GET_SELECTED_OPTIONS = 'getSelectedOptions';
export const SET_SELECTED_OPTION = 'setSelectedOption';
export const SET_PARAM_OPTIONS = 'setParamOptions';

export const GET_LEAGUES = 'getLeagues';
export const GET_SELECTED_LEAGUES = 'getSelectedLeagues';
export const POST_SELECTED_LEAGUES = 'postSelectedLeagues';

export const GET_ADDONS = 'getAddons';
export const GET_SELECTED_ADDONS = 'getSelectedAddons';
export const POST_SELECTED_ADDONS = 'postSelectedAddons';

export const GET_TEAMS = 'getTeams';
export const GET_SELECTED_TEAMS = 'getSelectedTeams';
export const POST_SELECTED_TEAMS = 'postSelectedTeams';

export const GET_GROUPS = 'getGroups';

export const POST_GROUP = 'postGroup';
export const UPDATE_GROUP = 'updateGroup';
export const DELETE_GROUP = 'deleteGroup';

export const POST_SCREEN = 'postScreen';
export const UPDATE_SCREEN = 'updateScreen';
export const DELETE_SCREEN = 'deleteScreen';

export const GET_SCHEDULE = 'getSchedules';
export const FAVORITE_BROADCAST = 'favoriteBroadcast';
export const PREFER_BROADCAST = 'preferBroadcast';